import { AlertCircle, Smartphone } from 'lucide-react'

export default function AuthErrorPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertCircle className="h-8 w-8 text-amber-600" />
            </div>
          </div>
          
          <h1 className="text-2xl font-poppins font-bold text-gray-900 text-center mb-4">
            Authentication Required
          </h1>
          
          <p className="text-gray-600 text-center mb-6">
            This page can only be accessed from the ReferPal mobile app. Please use the app to manage your account and subscription.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <Smartphone className="h-5 w-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-semibold text-blue-900 mb-1">
                  How to Access
                </h3>
                <ol className="text-sm text-blue-800 space-y-1 list-decimal list-inside">
                  <li>Open the ReferPal mobile app</li>
                  <li>Go to your Profile tab</li>
                  <li>Tap "Manage Account" button</li>
                </ol>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-sm text-gray-500">
              Don't have the app?{' '}
              <a 
                href="#" 
                className="text-primary-600 hover:text-primary-700 font-medium"
              >
                Download ReferPal
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
